import React from "react";
import { FunctionsContext } from "../../global/contexts";
import { WalletProviderDrawer } from "../wallet-provider-drawer/wallet-provider-drawer.component";

interface ITeMainProps {
  navigation: any;
  main: any;
  sidebar?: any;
}

const defaultProps: ITeMainProps = {
  navigation: null,
  main: null,
  sidebar: null
};

export function TeMain(props = defaultProps) {
  const { setActiveOverlay } = React.useContext(FunctionsContext);

  return (
    <div className="etx-body-wrapper">
      <main className="etx-body">
        <div className="FaqIndicator" onClick={() => setActiveOverlay("FAQ")}>
          <div className="FaqIndicator__text">
            <p className="font-weight-medium">FAQ</p>
          </div>

          <div className="FaqIndicator__icon">
            <i className="fal fa-question"></i>
          </div>
        </div>

        <WalletProviderDrawer />

        <aside className="etx-body__aside">{props.navigation}</aside>
        <section className="etx-body__main">{props.main}</section>
        {props.sidebar ?? ""}
      </main>
    </div>
  );
}
